var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicantsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user--multiple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V25a5.0057,5.0057,0,0,0-5-5V18a7.0078,7.0078,0,0,1,7,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2V4a5,5,0,0,1,0,10v2A7,7,0,0,0,20,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantsIcon);
export default __webpack_public_path__ + "static/media/applicantsIcon.df269f2309ccbc3699c3620919fd4647.svg";
export { ForwardRef as ReactComponent };